import {VariantConfigT} from '@/lib/types/colors.types';

export const blueConfig: VariantConfigT = {
  basic: {
    icon: 'blue',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'blue',
    active: 'blue',
  },
  outline: {
    icon: 'blue',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'blue',
    iconHover: 'blue',
    iconActive: 'blue',
    hover: 'blue',
    active: 'blue',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
